import { Collections } from "@diacare/common/models/collections";
import { FieldType } from "@litbase/admin";
import { Bell } from "@styled-icons/boxicons-regular";
import { ExtendedModelConfig } from "./index";

export const notificationConfig: ExtendedModelConfig = {
  name: Collections.NOTIFICATIONS,
  displayName: "Notifications",
  singleName: "Notification",
  newLabel: "New notification",
  listLabel: "Notifications",
  fields: {
    title: { type: FieldType.string, displayName: "Title" },
    descriptionHu: { type: FieldType.text, displayName: "Description (Hungarian)" },
    descriptionEn: { type: FieldType.text, displayName: "Description (English)" },
    enabled: { type: FieldType.bool, displayName: "Enabled" },
    createdAt: { type: FieldType.date, displayName: "Created at" },
  },
  icon: Bell,
  queryFields: {
    _id: 1,
    title: 1,
    descriptionHu: 1,
    descriptionEn: 1,
    enabled: 1,
    createdAt: 1,
  },
};
